import { CultureInfo } from '../culture-info.model';
import { CultureInfoIt } from './it';

/**
 * @ignore
 */
export const CultureInfoItSM: CultureInfo = {
  name: 'it-SM',
  displayName: 'italiano (San Marino)',
  iso3LanguageCode: 'ita',
  iso2LanguageCode: 'it',
  ietfLanguageTag: 'it-SM',
  parent: CultureInfoIt
};
